<template>
    <div style="display: flex; gap: 5px; min-width:400px;" v-if="(!type || type === 'button') && $can('translate', 'intento')">
        <select v-model="filter_language_iso" class="form-control" style="width: 80px;">
            <option value="">-</option>
            <option v-for="language in languages.filter((language) => language.iso != 'es')"
                :key="language.id" :value="language.iso">
                {{ language.iso.toUpperCase() }}
            </option>
        </select>
        <button
            type="button"
            :disabled="loadingIntento"
            @click="sendIntento()"
            class="btn btn-outline-danger d-flex"
            style="gap: 7px; align-items: center; font-weight: bold;"
        >
            <span class="d-flex">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send" viewBox="0 0 16 16">
                    <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z"/>
                </svg>
            </span>
            <span class="d-flex">{{ $t('intento.button.send') }}</span>
        </button>
        <button
            type="button"
            @click="downloadIntento()"
            class="btn btn-outline-danger d-flex"
            :disabled="loadingIntento"
            style="gap: 7px; align-items: center; font-weight: bold;"
        >
            <span class="fa fa-download"></span>
        </button>
    </div>
    <div class="col-auto p-0" v-else-if="type === 'feedback' && $can('feedback', 'intento')">
        <div class="d-flex" v-if="show_rating && !show_comment">
            <div class="col-auto p-0 pr-2">
                <select class="form-control" v-model="rating">
                    <option value="0">{{ $t('intento.label.not_understandable') }}</option>
                    <option value="1">{{ $t('intento.label.hardly_understandable') }}</option>
                    <option value="2">{{ $t('intento.label.understandable') }}</option>
                    <option value="3">{{ $t('intento.label.good') }}</option>
                </select>
            </div>
            <button
                type="button"
                @click="sendFeedbackIntento()"
                class="btn btn-outline-danger d-flex"
                :disabled="loadingIntento"
                style="gap: 7px; align-items: center; font-weight: bold;"
            >
                <span class="d-flex">{{ $t('intento.button.send_feedback') }}</span>
            </button>
        </div>
        <button v-else
            type="button"
            @click="showModal"
            class="btn btn-outline-danger d-flex"
            :disabled="loadingIntento"
            style="gap: 7px; align-items: center; font-weight: bold;"
        >
            <span class="d-flex">{{ $t('intento.button.feedback') }}</span>
        </button>

        <b-modal ref="modal" :title="`${ $t('intento.label.title') }`" centered size="md" :no-close-on-backdrop=true :no-close-on-esc=true>
            <div class="form">
                <div class="form-group">
                    <label>{{ $t('intento.label.rating') }}</label>
                    <select class="form-control" v-model="rating">
                        <option value="0">{{ $t('intento.label.not_understandable') }}</option>
                        <option value="1">{{ $t('intento.label.hardly_understandable') }}</option>
                        <option value="2">{{ $t('intento.label.understandable') }}</option>
                        <option value="3">{{ $t('intento.label.good') }}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label>{{ $t('intento.label.issue_type') }}</label>
                    <select class="form-control" v-model="issue_type">
                        <option value="">-</option>
                        <option value="Grammar">{{ $t('intento.label.grammar') }}</option>
                        <option value="Terminology">{{ $t('intento.label.terminology') }}</option>
                        <option value="Style issue">{{ $t('intento.label.style_issue') }}</option>
                        <option value="Tone of voice">{{ $t('intento.label.tone_of_voice') }}</option>
                        <option value="Structural issue">{{ $t('intento.label.structural_issue') }}</option>
                        <option value="Omission / Addition">{{ $t('intento.label.omission_addition') }}</option>
                        <option value="Brand compliance">{{ $t('intento.label.brand_compliance') }}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label>{{ $t('intento.label.comment') }}</label>
                    <textarea class="form-control" :placeholder="`${ $t('intento.label.comment') }..`" rows="3" v-model="comment" />
                </div>
            </div>
            <div slot="modal-footer">
                <button
                    type="button"
                    @click="sendFeedbackIntento()"
                    class="btn btn-outline-danger"
                    :disabled="loadingIntento"
                    style="gap: 7px; align-items: center; font-weight: bold;"
                >
                    <span class="d-flex">{{ $t('intento.button.send_feedback') }}</span>
                </button>
                <button @click="hideModal()" class="btn btn-danger">{{ $t('global.buttons.cancel') }}</button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { API_INTENTO } from './../api'
import BModal from 'bootstrap-vue/es/components/modal/modal'

export default {
    components: {
        BModal
    },
    name: 'Intento-Button',
    props: {
        type: {
            type: String,
            default: 'button',
        },
        languages: {
            type: Array,
            required: true
        },
        form: {
            type: Object,
            required: true
        },
        language_id: {
            type: [String, Number],
            required: true
        },
        keys: {
            type: Array,
            default: []
        },
        fields: {
            type: Array,
            default: []
        },
        field: String,
        item: {
            type: [String, Array],
            default: 'name',
        },
        value: {
            type: String,
            default: ''
        },
        show_comment: {
            type: Boolean,
            default: true,
        },
        show_rating: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        filter_language_iso: '',
        loadingIntento: false,
        translate_original: '',
        issue_type: '',
        rating: 0,
        comment: '',
    }),
    created: function () {
        if(this.type === 'feedback')
        {
            if(this.value)
            {
                this.translate_original = this.getValueByPath(this.value, this.language_id);
            }
            else
            {
                this.translate_original = this.form[this.field][this.language_id][this.item];
            }

            console.log(this.form, this.value, this.language_id, this.translate_original);
        }
    },
    methods: {
        hideModal () {
            if(this.show_rating && this.show_comment)
            {
                this.$refs['modal'].hide()
            }
        },
        showModal () {
            this.rating = 0
            this.comment = ''

            this.$refs['modal'].show()
        },
        getValueByPath(path, language_id) {
            const fullPath = path.replace('language_id', language_id);
            let current = this.form;
            const parts = fullPath.replace('form.', '').split('.');

            for (const part of parts) {
                if (!current) return undefined;

                const brackets = part.split('[');
                const key = brackets[0];

                current = current[key];

                for (let i = 1; i < brackets.length; i++) {
                    if (!current) break;
                    const index = parseInt(brackets[i].replace(']', ''));
                    current = current[index];
                }
            }

            return current;
        },
        setValueByPath(obj, path, value) {
            const parts = path.split('.');
            const lastPart = parts.pop();
            let current = obj;

            for (const part of parts) {
                if (part.includes('[')) {
                    const segments = part.split(/[\[\]]/).filter(seg => seg !== '');
                    current = segments.reduce((curr, segment, idx) => {
                        if (idx === 0) {
                            if (!curr[segment]) curr[segment] = [];
                            return curr[segment];
                        } else {
                            const index = parseInt(segment);
                            if (!curr[index]) curr[index] = {};
                            return curr[index];
                        }
                    }, current);
                } else {
                    if (!current[part]) current[part] = {};
                    current = current[part];
                }
            }

            if (current && lastPart) {
                current[lastPart] = value;
            }
        },
        async downloadIntento() {
            this.loadingIntento = true;
            try {
                const { data } = await API_INTENTO.get('/export');
                this.loadingIntento = false;

                if(data.success)
                {
                    window.location.href = data.download_url;
                }
                else
                {
                    this.$notify({
                        group: 'main',
                        type: 'error',
                        title: 'Error al descargar el archivo',
                        text: data.message ?? 'Ocurrió un error al descargar el archivo. Por favor, intente nuevamente.',
                    });
                }
            } catch (error) {
                console.error("Error al descargar el archivo:", error);
                this.$notify({
                    group: 'main',
                    type: 'error',
                    title: 'Descarga de archivo',
                    text: 'No se encontraron resultados para descargar.',
                });
                this.loadingIntento = false;
            }
        },
        async sendIntento() {
            this.loadingIntento = true;

            const targetLanguages = this.languages
                .filter((language) => language.iso !== 'es')
                .filter((language) => language.iso === this.filter_language_iso || this.filter_language_iso === '');

            const allTextInfo = [];
            let textIndex = 0;

            for (const field of this.fields) {
                let _item_ = this.item;

                if (typeof this.item === 'array' || typeof this.item === 'object') {
                    _item_ = this.item[field];
                }

                const value = this.form[field][this.language_id][_item_] ?? '';

                allTextInfo.push({
                    text: value,
                    type: 'field',
                    field: field,
                    itemKey: _item_,
                    originalIndex: textIndex++
                });
            }

            for (let key of this.keys) {
                const value = this.getValueByPath(key, this.language_id) ?? '';

                allTextInfo.push({
                    text: value,
                    type: 'key',
                    keyPath: key,
                    originalIndex: textIndex++
                });
            }

            const translationPromises = allTextInfo.map(async (textInfo) => {
                const params = {
                    "texts": [textInfo.text],
                    "targetLanguages": targetLanguages.map((language) => language.iso)
                };

                try {
                    const result = await API_INTENTO.post('/translate', params);
                    const responseData = result.data;

                    if (!responseData.isSync) {
                        const resolvedData = await Promise.all(
                            responseData.data.map(async item => {
                                const results = await this.pollTranslationOperation(item.operationId);
                                return { language: item.language, status: 'success', results };
                            })
                        );
                        return { ...textInfo, data: resolvedData };
                    }

                    return { ...textInfo, data: responseData.data };
                } catch (error) {
                    console.error(`Error traduciendo texto en índice ${textInfo.originalIndex}:`, error);
                    return {
                        ...textInfo,
                        data: [{ status: 'error', results: [] }]
                    };
                }
            });

            try {
                const results = await Promise.all(translationPromises);

                const updatedForm = JSON.parse(JSON.stringify(this.form));

                for (const result of results) {
                    for (const dataItem of result.data) {
                        if (dataItem && dataItem.status === 'success') {
                            for (const language of targetLanguages) {
                                if (language.iso.toLowerCase() === dataItem.language.toLowerCase()) {
                                    const translatedText = dataItem.results[0];

                                    if (result.type === 'field') {
                                        if (updatedForm[result.field] && updatedForm[result.field][language.id]) {
                                            updatedForm[result.field][language.id][result.itemKey] = translatedText;
                                        }
                                    } else if (result.type === 'key') {
                                        const path = result.keyPath.replace('form.', '').replace('language_id', language.id);
                                        this.setValueByPath(updatedForm, path, translatedText);
                                    }
                                }
                            }
                        }
                    }
                }

                this.$emit('update:form', updatedForm);
                this.$emit('form-updated', updatedForm);

                this.$notify({
                    group: 'main',
                    type: 'success',
                    title: 'Traducciones generadas',
                    text: 'Las traducciones se generaron correctamente.',
                });

            } catch (error) {
                console.error("Error al procesar las traducciones:", error);
                this.$notify({
                    group: 'main',
                    type: 'error',
                    title: 'Error de Traducción',
                    text: 'Ocurrió un error al intentar generar las traducciones.',
                });
            } finally {
                this.loadingIntento = false; // Detener la carga
            }
        },

        async pollTranslationOperation(operationId, maxRetries = 20, intervalMs = 3000) {
            for (let attempt = 0; attempt < maxRetries; attempt++) {
                await new Promise(resolve => setTimeout(resolve, intervalMs));

                const { data } = await API_INTENTO.get(`/operation/${operationId}`);

                if (data.status === 'done') {
                    return data.results;
                }

                if (data.status === 'failed') {
                    throw new Error(data.error?.message ?? 'Error en la operación de traducción asíncrona.');
                }
            }

            throw new Error('Se agotaron los reintentos esperando la traducción asíncrona.');
        },

        async sendFeedbackIntento() {
            const language_iso = this.languages
                .find((language) => language.id === this.language_id)?.iso ?? '';
            const language_id_original = this.languages
                .find((language) => language.iso === 'es')?.id ?? 0;

            let text_original = '', currentTranslation = '';

            if(this.value)
            {
                text_original = this.getValueByPath(this.value, language_id_original);
                currentTranslation = this.getValueByPath(this.value, this.language_id);
            }
            else
            {
                text_original = this.form[this.field][language_id_original][this.item];
                currentTranslation = this.form[this.field][this.language_id][this.item];
            }

            const params = {
                source: "es",
                source_text: text_original,
                target: language_iso,
                target_text: this.translate_original,
                suggested_translation: currentTranslation,
                translation_rating: this.rating,
                issue_type: this.issue_type,
                comment: this.comment,
            };

            this.hideModal();
            this.loadingIntento = true;

            try {
                await API_INTENTO.post('/feedback', params);

                this.$notify({
                    group: 'main',
                    type: 'success',
                    title: 'Feedback enviado',
                    text: 'El feedback fue enviado correctamente.',
                });

            } catch (error) {
                console.error('Error sending feedback:', error);
                this.$notify({
                    group: 'main',
                    type: 'error',
                    title: 'Error interno',
                    text: error.response?.data?.message || error.message || 'Ocurrió un error. Por favor, intente nuevamente.',
                });
            } finally {
                this.loadingIntento = false;
            }
        }
    }
}
</script>

<style>
.modal-backdrop {
    opacity: 0.4!important;
}
</style>
